import React from 'react';
import { fieldMarkers } from "../../../common/constants/export";
import { generateFileName } from "../../../common/helpers/export";
import { coverageChartTooltips, dealStatusCodes } from '../../constants/agentProductionConstants';

export const exportTypes = Object.freeze({
    agentDetailSearchResults: 'agentDetailSearchResults',
});

export const exportFilenameTemplates = {
    agentDetailSearchResults: `${fieldMarkers.AGENT_NAME} ${fieldMarkers.TAB_LABEL} in ${fieldMarkers.MLS_NAME} for ${fieldMarkers.PERIOD}`,
};

export const getAgentDetailFileName = ({ exportType, agentName, selectedTabLabel, mlsName, periods }) => {
    return generateFileName(exportFilenameTemplates[exportType] || '', {
        [fieldMarkers.AGENT_NAME]: agentName,
        [fieldMarkers.TAB_LABEL]: selectedTabLabel,
        [fieldMarkers.PERIOD]: periods,
        [fieldMarkers.MLS_NAME]: mlsName,
    });
};

export const getFilename = (exportDetails) => ({
    [exportTypes.agentDetailSearchResults]: getAgentDetailFileName(exportDetails),
});

export const getEllipsis = (node, cellText) => {
    if (!React.isValidElement(node) && !cellText) return node;
    const text = node?.props?.children || cellText;
    if (typeof text !== 'string' || text.length <= 10 && node) {
        return node;
    }
    if (node) {
        return React.cloneElement(node, {
            children: `${text.substring(0, 10)}...`
        });
    }
    const TEXT_LENGTH_LIMIT = 27;
    if (text.length > TEXT_LENGTH_LIMIT) return `${text.substring(0, TEXT_LENGTH_LIMIT)}...`;
    return text;    
};

export const statusTypeOptions = {
    [dealStatusCodes.SOLD.value]: dealStatusCodes.SOLD,
    [dealStatusCodes.ACTIVE.value]: dealStatusCodes.ACTIVE,
    [dealStatusCodes.UNDER_CONTRACT.value]: dealStatusCodes.UNDER_CONTRACT
};

export const chartDataTypeOptions = [
    { value: coverageChartTooltips.volumeBtn.id, label: coverageChartTooltips.volumeBtn.label },
    { value: coverageChartTooltips.unitsBtn.id, label: coverageChartTooltips.unitsBtn.label },
];
